/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  const style = document.createElement('style');
  style.textContent = `
    #sobefy__accesories-upsell-modal-popup,
    #sobefy__accesories-upsell-modal {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }
  `;
  document.head.appendChild(style);
})();

document.addEventListener('product:added', function(event) {
  const lightboxContainer = document.getElementById("sobefy__accesories-upsell-modal");
  const popupModal = document.getElementById("sobefy__accesories-upsell-modal-popup");
  
  if (lightboxContainer) {
    lightboxContainer.style.display = "none";
    lightboxContainer.style.visibility = "hidden";
    lightboxContainer.style.opacity = "0";
  }
  
  if (popupModal) {
    popupModal.style.display = "none";
    popupModal.style.visibility = "hidden";
    popupModal.style.opacity = "0";
  }

  var isFromAccessories = false;
  var context = window.__lastAddToCartContext;
  
  if (context && context.expires <= Date.now()) {
    window.__lastAddToCartContext = null;
    context = null;
  }
  
  var isFromSample = false;
  
  if (event.detail && event.detail.fromAccessories === true) {
    isFromAccessories = true;
  }
  else if (event.detail && event.detail.button) {
    var button = event.detail.button;
    if (button.closest && button.closest('.accessories_upsell')) {
      isFromAccessories = true;
    }
  }
  else if (context && context.preventRedirect) {
    isFromAccessories = true;
  }
  
  if (event.detail && event.detail.fromSample === true) {
    isFromSample = true;
  } else if (event.detail && event.detail.button) {
    var button = event.detail.button;
    if (button.hasAttribute && (button.hasAttribute('data-is-sample') || button.hasAttribute('data-sample-order'))) {
      isFromSample = true;
    }
  } else if (window.__isSampleOrder === true || window.__preventCartRedirect === true) {
    isFromSample = true;
  }

  if (isFromAccessories || isFromSample) {
    window.__lastAddToCartBtn = null;
    window.__isSampleOrder = false;
    window.__preventCartRedirect = false;
    return;
  }
  
  var href = window.location.href;
  var alreadyOnAddedPage = href.indexOf('/pages/add-to-cart') !== -1 || href.indexOf('view=added-to-cart') !== -1;
  if (!alreadyOnAddedPage) {
    var productId = '';
    if (event.detail && event.detail.variant && event.detail.variant.product_id) {
      productId = event.detail.variant.product_id;
    }
    
    var redirectUrl = productId 
      ? '/pages/add-to-cart?view=added-to-cart&product_id=' + productId
      : '/pages/add-to-cart?view=added-to-cart';
    window.location.href = redirectUrl;
  }
});

document.addEventListener('click', function(e) {
  var btn = e.target.closest('button.product-form__add-button[data-action="add-to-cart"], button.product-item__action-button[data-action="add-to-cart"]');
  if (!btn) return;
  
  var form = btn.closest('form');
  if (!form) return;
  
  var idInput = form.querySelector('input[name="id"]');
  var quantityInput = form.querySelector('[name="quantity"]');
  var variantId = idInput && idInput.value ? Number(idInput.value) : null;
  var quantity = Math.max(1, parseInt((quantityInput && quantityInput.value) || '1', 10) || 1);
  
  if (!variantId || !isFinite(variantId)) return;

  var isFromAccessories = !!btn.closest('.accessories_upsell');
  
  var isFromSample = btn.hasAttribute('data-is-sample') || 
                      btn.hasAttribute('data-sample-order') ||
                      window.__isSampleOrder === true ||
                      window.__preventCartRedirect === true;
  
  var context = {
    preventRedirect: isFromAccessories || isFromSample,
    expires: Date.now() + 5000
  };
  
  window.__lastAddToCartBtn = btn;
  window.__lastAddToCartContext = context;
  
  if (window.__lastAddToCartContextCleanupTimer) {
    clearTimeout(window.__lastAddToCartContextCleanupTimer);
  }
  window.__lastAddToCartContextCleanupTimer = setTimeout(function(){
    window.__lastAddToCartContext = null;
  }, 5000);

  e.preventDefault();
  e.stopPropagation();
  btn.disabled = true;
  var originalText = btn.textContent;
  btn.textContent = 'Adding…';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin',
    body: JSON.stringify({ id: variantId, quantity: quantity })
  }).then(function(res){
    if (!res.ok) return res.json().then(function(j){ throw j; });
    return res.json();
  }).then(function(payload){
    btn.textContent = 'Added';
    setTimeout(function(){ 
      btn.textContent = originalText; 
      btn.disabled = false; 
    }, 800);
    
    if (context && payload && payload.product_id) {
      context.variant = payload;
    }
    
    document.documentElement.dispatchEvent(new CustomEvent('product:added', { 
      bubbles: true, 
      detail: { 
        quantity: quantity, 
        variant: payload,
        button: btn,
        fromAccessories: isFromAccessories,
        fromSample: isFromSample
      } 
    }));
  }).catch(function(){
    btn.textContent = 'Try again';
    setTimeout(function(){ 
      btn.textContent = originalText; 
      btn.disabled = false; 
    }, 1200);
    window.__lastAddToCartContext = null;
    window.__lastAddToCartBtn = null;
  });
});